import { SearchVisitor } from '../model/searchvisitor';
import { Identity } from '@sdbn/common';
import { VisitReservation } from '../model/visit-reservation';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitReservationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getNewVisitReservation(visitorIdentity: Identity): Observable<VisitReservation> {
    const url = `/client/visitreservation/newreservation`;
    return this.appServerAPI.execute<VisitReservation>(url, visitorIdentity);
  }

  public getVisitReservation(identity: Identity): Observable<VisitReservation> {
    return this.appServerAPI.execute<VisitReservation>('/client/visitreservation/details', identity);
  }

  public saveVisitReservation(personalVisit: VisitReservation): Observable<any> {
    return this.appServerAPI.execute<any>('/client/visitreservation/save', personalVisit);
  }

  public deleteVisitReservation(identity: Identity): Observable<any> {
    return this.appServerAPI.execute<VisitReservation>('/client/visitreservation/delete', identity);
  }

  public search(searchVisitor: SearchVisitor): Observable<any> {
    return this.appServerAPI.execute<any>('/client/visitreservation/search', searchVisitor);
  }


}
